import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditSkill from "../../components/skills/FormAddEditSkill";
import { useGetSkill } from "../../hooks/skills/useGetSkill";
import LoadingPage from "../../components/global/LoadingPage";

const EditSkill = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, skill } = useGetSkill(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/skills");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSkill
                isEdit={true}
                currentData={skill}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditSkill;